var _defs, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgManageJob = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21.139,
    height: 19.729,
    viewBox: "0 0 21.139 19.729",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-managejob {\r\n        fill: #fff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Solid",
    transform: "translate(-16 -32)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5981",
    "data-name": "Group 5981",
    transform: "translate(16 32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12712",
    "data-name": "Path 12712",
    className: "cls-managejob",
    d: "M418.114,329.409H416v.7h2.466a.352.352,0,0,0,.352-.352V328h-.7Z",
    transform: "translate(-398.384 -314.964)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12713",
    "data-name": "Path 12713",
    className: "cls-managejob",
    d: "M384,360h.7v.7H384Z",
    transform: "translate(-367.794 -345.555)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12714",
    "data-name": "Path 12714",
    className: "cls-managejob",
    d: "M464,296h.7v.7H464Z",
    transform: "translate(-444.271 -284.374)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12715",
    "data-name": "Path 12715",
    className: "cls-managejob",
    d: "M64.7,112.7h.7V112H64.352a.352.352,0,0,0-.352.352v2.466h.7Z",
    transform: "translate(-61.886 -108.477)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12716",
    "data-name": "Path 12716",
    className: "cls-managejob",
    d: "M112,112h.7v.7H112Z",
    transform: "translate(-107.772 -108.477)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12717",
    "data-name": "Path 12717",
    className: "cls-managejob",
    d: "M64,192h.7v.7H64Z",
    transform: "translate(-61.886 -184.954)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12718",
    "data-name": "Path 12718",
    className: "cls-managejob",
    d: "M67.875,264.1a.352.352,0,0,1,.158.037l.63.315h2.652l.63-.315a.352.352,0,0,1,.158-.037h3.875V256H64v8.1Zm5.989-7.4h1.057a.352.352,0,0,1,.352.352v1.057h-.7v-.7h-.7Zm-9.16,5.285h.7v.7h.7v.7H65.057a.352.352,0,0,1-.352-.352Z",
    transform: "translate(-61.886 -246.135)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12719",
    "data-name": "Path 12719",
    className: "cls-managejob",
    d: "M32.7,225.057a.352.352,0,0,1,.352-.352H45.74a.352.352,0,0,1,.352.352v8.456h.7v-8.984a.529.529,0,0,0-.528-.528H32.528a.529.529,0,0,0-.528.528v8.984h.7Z",
    transform: "translate(-31.295 -215.544)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12720",
    "data-name": "Path 12720",
    className: "cls-managejob",
    d: "M25.67,456.315a.352.352,0,0,1-.158.037H22.694a.352.352,0,0,1-.158-.037l-.63-.315H16v.528a.529.529,0,0,0,.528.528H31.678a.529.529,0,0,0,.528-.528V456H26.3Z",
    transform: "translate(-16 -437.327)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12721",
    "data-name": "Path 12721",
    className: "cls-managejob",
    d: "M384,240h4.932v1.057H384Z",
    transform: "translate(-367.794 -230.84)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12722",
    "data-name": "Path 12722",
    className: "cls-managejob",
    d: "M159.061,32H144.44a.44.44,0,0,0-.44.44v7.31h9.336a1.235,1.235,0,0,1,1.114.7H159.5V32.44A.44.44,0,0,0,159.061,32Zm-.264,2.114h-.7v-.7h-.7v-.7h1.057a.352.352,0,0,1,.352.352Z",
    transform: "translate(-138.363 -32)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgManageJob, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ManageJob.06f44624.svg";
export { ForwardRef as ReactComponent };